import {TargetData} from './TargetData';
import {Address} from './Address';
import {Consent} from './Consent';
import {Property} from './Property';
import {UserRole} from './UserRole';
import {NotificationMessage} from "../notifications/NotificationMessage";
import {UserWallet} from "./UserWallet";
import {UserPromotion} from "./UserPromotion";

export class User {
    userName!: string;
    email!: string;
    msisdn!: string;
    msisdnConfirmed!: boolean;
    accountBalance!: number;
    targetData!: TargetData[];
    addresses!: Address[];
    consents!: Consent[];
    properties: Property[] = [];
    roles!: UserRole[];
    notifications!: NotificationMessage[];
    activationCode!: string;
    userWallets!: UserWallet[];
    hasSellThisMonth!: boolean;
    sellThisMonth!: number;
    currentPromotion!: UserPromotion;
    get HomeAddress(): Address {
        return this.getAddress(1);
    }
    set HomeAddress(value: Address) {
        this.setAddress(1, value);
    }
    get IRSAddress(): Address {
        return this.getAddress(2);
    }
    set IRSAddress(value: Address) {
        this.setAddress(2, value);
    }
    get irsCode(): string {
      return this.getProperty('irsCode').toString();
    }
    set irsCode(value: string) {
      this.setProperty('irsCode', value.toString());
    }
    get MailingAddress(): Address {
        return this.getAddress(3);
    }
    set MailingAddress(value) {
        this.setAddress(3, value);
    }
    get AccountNumber(): string {
        return this.getProperty('accountNumber');
    }
    set AccountNumber(value: string) {
        this.setProperty('accountNumber', value);
    }
    get BankName(): string {
        return this.getProperty('bankName');
    }
    set BankName(value) {
        this.setProperty('bankName', value);
    }
    setConsent(consentUid: string, isChecked: boolean) {
      const propIndex = this.consents.findIndex(x => x.consentUid == consentUid);
      if (propIndex > -1) {
        this.consents[propIndex].isChecked = isChecked;
      }
    }
    getProperty(name: string): string {
        const result = this.properties.filter(x => x.key === name);
        if (result != null && result.length === 1) {
            return result[0].value;
        } else {
            return '';
        }
    }
    setProperty(name: string, value: string) {
        let propIndex = this.properties.findIndex(x => x.key === name);
        if (propIndex === -1) {
            this.properties.push(new Property({ key: name, value: value }));
            propIndex = this.properties.length - 1;
        }
        this.properties[propIndex].value = value;
    }

    get getCurrentTarget(): TargetData {
        return this.targetData[this.targetData.length - 1];
    }
    get personType(): string {
        return this.getProperty('personType');
    }
    set personType(value: string) {
        this.setProperty('personType', value);
    }
    get firstName(): string {
        return this.getProperty('firstName');
    }
    set firstName(value: string) {
        this.setProperty('firstName', value);
    }
    get companyName(): string {
        return this.getProperty('companyName');
    }
    set companyName(value: string) {
        this.setProperty('companyName', value);
    }
    get lastName(): string {
        return this.getProperty('lastName');
    }
    set lastName(value: string) {
        this.setProperty('lastName', value);
    }
    get VAT(): string {
        return this.getProperty('VAT');
    }
    set VAT(value: string) {
        this.setProperty('VAT', value);
    }
    get birthdate(): string {
        return this.getProperty('DOB');
    }
    set birthdate(value: string) {
        this.setProperty('DOB', value);
    }
    get mobile(): string {
        return this.getProperty('mobile');
    }
    set mobile(value: string) {
        this.setProperty('mobile', value);
    }
    get hasIrsCode(): boolean {
      const code = this.irsCode.toString();
      console.log('IRS_CODE: ' + this.irsCode);
      console.log('IRS_CODE_NULL: ' + (this.irsCode != null));
      console.log(this.irsCode);
      console.log('IRS_CODE_LENGTH: ' + code.trim().length);
      return (code.length > 0);
    }
    get isAccountNumberValid(): boolean {
        return this.NRBvalidatior(this.getProperty('accountNumber'));
    }
    get isAccountNumberShowValidator(): boolean {
        return !this.isAccountNumberValid && this.getProperty('accountNumber') != null && this.getProperty('accountNumber').length > 0;
    }
    get isBankNameValid(): boolean {
        const rxRule = new RegExp('^[a-ząćęłńóśźżA-ZĄĆĘŁŃÓŚŹŻ0-9 ]{3,24}$');
        return rxRule.test(this.BankName);
    }
    get isBankNameShowValidator(): boolean {
        return !this.isBankNameValid && this.BankName != null && this.BankName.length > 0;
    }
    get isFirstNameValid(): boolean {
        const rxRule = new RegExp('^[a-ząćęłńóśźżA-ZĄĆĘŁŃÓŚŹŻ ]{1,24}$');
        return this.getProperty('firstName') != null && rxRule.test((this.getProperty('firstName')));
    }
    get isFirstNameShowValidator(): boolean {
        return !this.isFirstNameValid && this.getProperty('firstName') != null && this.getProperty('firstName').length > 0;
    }
    get isLastNameValid(): boolean {
        const rxRule = new RegExp('^[a-ząćęłńóśźżA-ZĄĆĘŁŃÓŚŹŻ \-]{1,24}$');
        return this.getProperty('lastName') != null && rxRule.test((this.getProperty('lastName')));
    }
    get isLastNameShowValidator(): boolean {
        return !this.isLastNameValid && this.getProperty('lastName') != null && this.getProperty('lastName').length > 0;
    }
    get isCompanyNameValid(): boolean {
        const rxRule = new RegExp('^(.{1,100})$');
        return this.getProperty('companyName') != null && rxRule.test((this.getProperty('companyName')));
    }
    get isCompanyNameShowValidator(): boolean {
        return !this.isCompanyNameValid && this.getProperty('companyName') != null && this.getProperty('companyName').length > 0;
    }
    get isVATValid(): boolean {
        const rxRule = new RegExp('^[0-9]{10}$');
        if (this.VAT == null || !rxRule.test(this.VAT)) {
            return false;
        } else {
            const digits = String(this.VAT).split('');
            // tslint:disable-next-line:max-line-length
            const checksum = (6 * parseInt(digits[0], 10) + 5 * parseInt(digits[1], 10) + 7 * parseInt(digits[2], 10) + 2 * parseInt(digits[3], 10) + 3 * parseInt(digits[4], 10) + 4 * parseInt(digits[5], 10) + 5 * parseInt(digits[6], 10) + 6 * parseInt(digits[7], 10) + 7 * parseInt(digits[8], 10)) % 11;
            return ( parseInt(digits[9], 10) === checksum);
        }
    }
    get isVATShowValidator(): boolean {
        return !this.isVATValid && this.VAT != null && this.VAT.length > 0;
    }
    get isPESELValid(): boolean {
        // Klasyczna walidacja wg algorytmu Luhna w implementacji PESEL
        // Klasyczna walidacja wg algorytmu Luhna z wagami stosowanymi przez MSWiA
        // Na podstawie: http://phpedia.pl/wiki/Walidacja_numeru_PESEL
        const rxRule = new RegExp('^[0-9]{11}$');
        if (this.VAT == null || !rxRule.test(this.VAT)) {
            return false;
        } else {
            // tablica z odpowiednimi wagami
            const arrWagi = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
            let intSum = 0;

            // mnożymy każdy ze znaków przez wagę i sumujemy wszystko
            for (let i = 0; i < 10; i++) {
                intSum += arrWagi[i] * parseInt(this.VAT[i], 10);
            }

            // obliczamy sumę kontrolną i porównujemy ją z ostatnią cyfrą.
            const int = 10 - intSum % 10;
            const intControlNr = (int === 10) ? 0 : int;
            // sprawdzamy czy taka sama suma kontrolna jest w ciągu
            if (intControlNr === parseInt(this.VAT[10], 10)){
                return true;
            }
            return false;
        }
    }
    get isPESELShowValidator(): boolean {
        return  !this.isPESELValid && this.VAT != null && this.VAT.length > 0;
    }
    get isDOBValid(): boolean {
        let d: Date | null = null;
        if (this.birthdate != null && this.birthdate.length >= 10) {
            d = new Date(this.birthdate);
        }
        return d != null && d.getFullYear() > 1900 && this.howOld(d) >= 18;
    }
    get isDOBShowValidator(): boolean {
        return !this.isDOBValid && this.birthdate != null && this.birthdate.length > 0;
    }
    get isMobileValid(): boolean {
        const rxRule = new RegExp('^[0-9]{9}$');
        return this.mobile != null && rxRule.test(this.mobile);
    }
    get isMobileShowValidator(): boolean {
        return this.mobile != null && this.mobile.length > 0 && !this.isMobileValid;
    }

    public isInRole(roleName: string): boolean {
        return this.roles.findIndex(r => r.roleName === roleName) > -1;
    }
    constructor(result: any) {
        this.userName = result.userName;
        this.email = result.email;
        this.mobile = result.mobile;
        this.accountBalance = result.accountBalance;
        this.msisdnConfirmed = result.msisdnConfirmed;
        this.hasSellThisMonth = result.hasSellThisMonth;
        this.sellThisMonth = result.sellThisMonth;
        if (result.currentPromotion) {
          if (result.currentPromotion.length === 1) {
            this.currentPromotion = new UserPromotion(result.currentPromotion[0]);
          }
        }
        this.userWallets = [];
        for(const i in result.userWallets) {
          this.userWallets.push(new UserWallet(result.userWallets[i]));
        }

        this.targetData = [];
        for (const i in result.targetData) {
            this.targetData.push(new TargetData(result.targetData[i]));
        }

        this.addresses = [];
        for (const i in result.addresses) {
            this.addresses.push(new Address(result.addresses[i]));
        }

        this.consents = [];
        for (const i in result.consents) {
            this.consents.push(new Consent(result.consents[i]));
        }

        this.properties = [];
        for (const i in result.properties) {
            this.properties.push(new Property(result.properties[i]));
        }

        this.roles = [];
        for (const i in result.roles) {
            this.roles.push(new UserRole(result.roles[i]));
        }

        this.notifications = [];
        for (const i in result.notifications) {
            this.notifications.push(new NotificationMessage(result.notifications[i]));
        }
        // console.log(this);
    }
    private getAddress(addressTypeId: number): Address {
        let index = this.addresses.findIndex(i => i.addressTypeId === addressTypeId);
        if (index === -1) {
            this.addresses.push(new Address({ addressTypeId: addressTypeId }));
            index = this.addresses.length - 1;
        }
        return this.addresses[index];
    }
    private setAddress(addressTypeId: number, value: Address) {
        const index = this.addresses.findIndex(i => i.addressTypeId === addressTypeId);
        if (index === -1) {
            this.addresses.push(value);
        } else {
            this.addresses[index] = value;
        }
    }
    private howOld(birthdate: Date): number {
        const today = new Date();
        if (birthdate.getMonth() > today.getMonth()) {
            return today.getFullYear() - birthdate.getFullYear() - 1;
        } else if (birthdate.getMonth() === today.getMonth()) {
            if (birthdate.getDate() > today.getDate()) {
                return today.getFullYear() - birthdate.getFullYear() - 1;
            } else {
                return  today.getFullYear() - birthdate.getFullYear();
            }
        } else {
            return today.getFullYear() - birthdate.getFullYear();
        }
    }
    private NRBvalidatior(nrb: any) {
        if (nrb == null) { return  false; }
        //nrb = nrb.replace(/[^0-9]+/g, '');
        if (nrb.startsWith('PL')) {
            nrb = nrb.substring(2);
        }
        nrb = nrb.replace(/\s/g, '');
        const wagi = new Array(1, 10, 3, 30, 9, 90, 27, 76, 81, 34, 49, 5, 50, 15, 53, 45, 62, 38, 89, 17, 73, 51, 25, 56, 75, 71, 31, 19, 93, 57);

        if (nrb.length === 26) {
            nrb = nrb + '2521';
            nrb = nrb.substr(2) + nrb.substr(0, 2);
            let Z = 0;
            for (let i = 0; i < 30; i++) {
                Z += nrb[29 - i] * wagi[i];
            }
            if (Z % 97 === 1) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
}
